<template>
  <div class="login">
    <div class="info hidden-xs-only">
      <img class="login_img" src="@/assets/img/login_img.png" />
      <img class="login_text" src="@/assets/img/login_text.png" />
      <p>视频创作 智能发布 操作便捷</p>
      <p>品牌曝光 排名优化 私域转化</p>
    </div>
    <div class="info hidden-sm-and-up">
      <img class="login_img" src="@/assets/img/login_img.png" />
    </div>
    <el-form
      class="form"
      ref="formRef"
      :model="formData"
      :rules="rules"
      hide-required-asterisk
    >
      <!-- <div class="logo" v-if="location.hostname === 'u.xiansuotu.com'"> -->
      <div class="logo" v-if="oem">
        {{ reactiveData.oem_info.oem_name || '后台管理' }}
      </div>
      <div class="logo" v-else>
        <img class="hidden-xs-only" src="@/assets/img/login_logo.png" />
        <img class="hidden-sm-and-up" src="@/assets/img/login_logo_wap.png" />
      </div>
      <el-form-item label="" prop="username">
        <el-input v-model="formData.username">
          <template #prefix>
            <img src="@/assets/img/login_icon1.svg" />
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="password">
        <el-input
          v-model="formData.password"
          type="password"
          autocomplete="off"
          show-password
        >
          <template #prefix>
            <img src="@/assets/img/login_icon2.svg" />
          </template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          style="width: 100%"
          @click="submitForm(formRef)"
          :loading="loading"
        >
          登录
        </el-button>
      </el-form-item>
    </el-form>
    <div class="info hidden-sm-and-up">
      <img class="login_text" src="@/assets/img/login_text.png" />
      <p>视频创作 智能发布 操作便捷</p>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, toRefs } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import { login, oem_info } from '@/utils/api'
import { is_oem } from '@/utils'

const store = useStore()
const { state } = store
const { loading } = toRefs(state)

const router = useRouter()
const route = useRoute()

const oem = is_oem()

const reactiveData = reactive({
  oem_info: {},
})

const formRef = ref()
const formData = reactive({
  username: process.env.NODE_ENV === 'production' ? '' : '',
  password: process.env.NODE_ENV === 'production' ? '' : '',
})

const default_rule = {
  message: '请输入',
}
const rules = reactive({
  username: [{ ...default_rule, required: true }],
  password: [{ ...default_rule, required: true }],
})

const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      login(formData).then(({ data: res }) => {
        if (res.state === 1) {
          ElMessage({
            type: 'success',
            message: res.info,
          })
          if (route.query.redirect) {
            router.replace({ path: route.query.redirect })
          } else {
            router.replace({ name: 'index' })
          }
        } else {
          ElMessage({
            type: 'error',
            message: res.info ?? '登录失败',
          })
        }
      })
    } else {
      console.log('error submit!', fields)
    }
  })
}

if (route.query.token) {
  login({
    username: route.query.username,
    token: route.query.token,
  }).then(({ data: res }) => {
    if (res.state === 1) {
      ElMessage({
        type: 'success',
        message: res.info,
      })
      if (route.query.redirect) {
        router.replace({ path: route.query.redirect })
      } else {
        router.replace({ name: 'index' })
      }
    } else {
      ElMessage({
        type: 'error',
        message: res.info ?? '登录失败',
      })
    }
  })
}
const location = ref(window.location)

if (oem) {
  oem_info().then(({ data: res }) => {
    reactiveData.oem_info = res.data ?? {}
    document.title = reactiveData.oem_info.oem_name || '后台管理'
  })
}
</script>

<style scoped lang="scss">
.login {
  /* position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999; */
  height: 100vh;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(@/assets/img/login_bg.png) center / cover;
  .info {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 215px;
    .login_img {
      margin-bottom: 60px;
    }
    .login_text {
      margin-bottom: 40px;
    }
    p {
      font-size: 25px;
      line-height: 33px;
      margin-bottom: 10px;
    }
  }
  .form {
    max-width: 80%;
    width: 577px;
    height: 364px;
    background-color: #fff;
    border-radius: 10px;
    padding: 30px 60px;
    .logo {
      text-align: center;
      margin-bottom: 25px;
      color: #000;
      font-size: 24px;
      font-weight: bold;
      line-height: 1;
    }
    .el-input {
      --el-input-height: 56px;
      --el-input-text-color: #060c14;
      --el-input-border-color: #86a4d3;
      --el-input-focus-border-color: #39a7fb;
      font-size: 16px;
      --el-fill-color-light: #fff;
    }
    .el-button {
      height: 56px !important;
      --el-button-bg-color: #005eff;
      --el-font-size-base: 18px;
      --el-button-font-weight: bold;
      border-radius: 0;
    }
    .el-form-item {
      margin-bottom: 25px;
    }
  }
}
@media screen and (max-width: 768px) {
  .login {
    flex-direction: column;
    .form {
      padding: 20px 30px 5px;
      height: auto;
      .el-input {
        --el-input-height: 30px;
      }
      .el-button {
        height: 30px !important;
        --el-font-size-base: 12px !important;
      }
      .el-form-item {
        margin-bottom: 16px;
        :deep(.el-input__prefix-inner) {
          width: 21px;
        }
        :deep(.el-input__inner) {
          font-size: 12px;
        }
      }
      .logo {
        margin-bottom: 15px;
        img {
          height: 18px;
        }
      }
    }
    .info {
      margin-right: 0;
      .login_img {
        margin-bottom: 45px;
        width: 235px;
      }
      .login_text {
        margin-top: 60px;
        margin-bottom: 16px;
        width: 275px;
      }
      p {
        font-size: 16px;
      }
    }
  }
}
</style>
